import { Injectable, isDevMode } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { interval, Observable, Subject, throwError } from 'rxjs';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  // public baseUrl = 'http://localhost:3001/api/v1/';
  // public socketUrl = 'http://localhost:3001';
  // public fileUrl = 'http://localhost:3001/api/v1/file?path=';

  public baseUrl = 'https://cvgold.ir/api/v1/';
  public socketUrl = 'https://cvgold.ir/';
  public fileUrl = 'https://cvgold.ir/api/v1/file?path=';

  public mobilePattern =
    /^(09)(((0)|(1)|(3)|(4)|(9))([0-9])|(20)|(21)|(22))(\d{7})/;
  onLogout: Subject<any>;

  onMobileScroll: Subject<any>;
  onGoToElement: Subject<any>;
  onQuickChatOpen: Subject<any>;
  onQuickChatClose: Subject<any>;

  constructor(
    public _toastController: ToastController,
    private _translocoService: TranslocoService
  ) {
    this.onLogout = new Subject();
    this.onMobileScroll = new Subject();
    this.onGoToElement = new Subject();
    this.onQuickChatOpen = new Subject();
    this.onQuickChatClose = new Subject();
  }

  /**
   * Convert persian numbers in string to english
   *
   * @param param
   * @returns string
   */
  num2en(param: string): string {
    const persianNum = [
      /۰/gi,
      /۱/gi,
      /۲/gi,
      /۳/gi,
      /۴/gi,
      /۵/gi,
      /۶/gi,
      /۷/gi,
      /۸/gi,
      /۹/gi,
    ];
    for (let i = 0; i < 10; i++) {
      param = param.replace(persianNum[i], i.toString());
    }
    return param;
  }

  /**
   * Convert english numbers in string to persian
   *
   * @param param
   * @returns string
   */
  num2fa(param: string): string {
    const len = param.length;
    let result = '';
    let pos;
    const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    for (let i = 0; i < len; i++) {
      if ((pos = persianNumbers[param.charAt(i)])) {
        result += pos;
      } else {
        result += param.charAt(i);
      }
    }
    return result;
  }

  /**
   * Handle errors
   *
   * @param error
   */
  handleError(error: any): void {
    if (error.status === 0) {
      this.showToast(
        this._translocoService.translate('error.offline'),
        'danger'
      );
    } else {
      this.showToast(
        this._translocoService.translate('error.unknown'),
        'danger'
      );
    }
  }

  async showToast(message, type): Promise<void> {
    const toast = await this._toastController.create({
      message: message,
      duration: 3000,
      color: type,
    });
    toast.present();
  }

  /**
   * Remove item from object array
   *
   * @param objectArray
   * @param propertyName
   * @param propertyVal
   * @returns array
   */
  removeFromObjArray(objectArray, propertyName, propertyVal): [] {
    return objectArray.filter(
      (element: any) => element[propertyName] !== propertyVal
    );
  }

  /**
   * Check if string only contains digits
   *
   * @param param
   * @returns boolean
   */
  hasOnlyDigits(param: string): boolean {
    return /^-?\d+$/.test(param);
  }

  /**
   * Check if string param is number
   *
   * @param param
   * @returns boolean
   */
  isNumeric(param: string): boolean {
    return !isNaN(parseFloat(param));
  }

  /**
   * Get current Geo location
   *
   * @returns object
   */
  getPosition$(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          resolve({
            lng: resp.coords.longitude,
            lat: resp.coords.latitude,
          });
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  /**
   * Custom log
   *
   * @param data
   */
  log(data: any): void {
    if (isDevMode()) {
      console.log({
        date: new Date(),
        data,
      });
    }
  }

  /**
   * Generate a random string
   *
   * @param length
   * @returns string
   */
  randomString(length: number = 10): string {
    let text = '';
    const possible =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  randomNumber(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  /**
   * Deep copy an object
   *
   * @param object
   * @returns object
   */
  deepCopy(object: any): any {
    let copy;

    // Handle the 3 simple types, and null or undefined
    if (null == object || 'object' != typeof object) {
      return object;
    }

    // Handle Date
    if (object instanceof Date) {
      copy = new Date();
      copy.setTime(object.getTime());
      return copy;
    }

    // Handle Array
    if (object instanceof Array) {
      copy = [];
      for (let i = 0, len = object.length; i < len; i++) {
        copy[i] = this.deepCopy(object[i]);
      }
      return copy;
    }

    // Handle Object
    if (object instanceof Object) {
      copy = {};
      for (const attr in object) {
        if (object.hasOwnProperty(attr)) {
          copy[attr] = this.deepCopy(object[attr]);
        }
      }
      return copy;
    }

    throw new Error('Unable to copy obj! Its type is not supported.');
  }

  ifInObjectArray(objectArray, findBy, value): boolean {
    if (objectArray) {
      for (const item of objectArray) {
        if (item[findBy] === value) {
          return true;
        }
      }
    }
    return false;
  }
}
